export interface OverviewData {
  label: string;
  value: string | any;
  type?: string;
  config?: any;
  options?: [] | any;
}
